<div class="header" data-region="header"></div>
<div class="content" data-region="content"></div>
<div class="footer" data-region="footer"></div>